__turbopack_context__.v({
  "wrapper": "vI8WYG_wrapper",
});
